<template>
  <v-card>
    <v-card-title class="justify-center">
       Инструкция по прохождению вступительных испытаний КузГТУ
    </v-card-title>
    <v-card-text class="px-15 ">
        Во время проведения вступительного испытания поступающий обязан обеспечить необходимые условия для работы:
      <ul>
        <li>
          достаточный уровень освещенности (световой поток должен быть достаточно сильным,
          чтобы видеопоток шел без помех; для этого можно сесть в хорошо освещенном помещении,
          напротив окна или включить настольную лампу);
        </li>
        <li>
          низкий уровень шума (лучше всего проходить вступительные испытания в тихом, спокойном месте);
        </li>
        <li>
          отсутствие помех при передаче видео и аудио сигналов (следует обеспечить стабильное интернет-подключение);
        </li>
        <li>
          оборудование пользователя позволяет обеспечить идентификацию его личности
          (рекомендуется использовать веб-камеру с матрицей 1.3Mpx (1280×1024) или более);
        </li>
        <li>
          заблаговременное проведение проверки технической возможности передачи видео и аудио сигналов
          (проверку можно осуществить по ссылке
          <a target="bb_test" href="https://bbb-6.kuzstu.ru/b/9mh-939-meb">
            https://bbb-6.kuzstu.ru/b/9mh-939-meb
          </a> );
        </li>
        <li>
          использование для идентификации оригинала документа, удостоверяющего его личность;
        </li>
        <li>
          концентрация на выполнении заданий на экране компьютера, без сосредоточения взгляда на посторонних предметах вне зоны видимости веб-камеры.
        </li>
      </ul>
      <br>
      При прохождении вступительного испытания поступающий не имеет права:
      <ul>
        <li>
          привлекать помощь третьих лиц;
        </li>
        <li>
          предоставить доступ к компьютеру посторонним лицам во время тестирования;
        </li>
        <li>
          вступать в разговоры с третьими лицами, проговаривать вопросы и задания громко вслух;
        </li>
        <li>
          использовать справочные материалы (книги, записи и т.д.), а также цифровые устройства (мобильные телефоны, планшеты и т.д.),
          наушники, калькуляторы, дополнительные мониторы, мыши, клавиатуры и любую иную компьютерную технику, кроме той, что непосредственно используется для экзамена.
        </li>
        <li>
          покидать зону видимости веб-камерой и отключать её;
        </li>
        <li>
          отключать микрофон или снижать уровень его чувствительности к звуку во время тестирования.
        </li>
      </ul>
      <p>
         Поступающий обязуется не передавать реквизиты доступа (логин, пароль) к своей учетной записи в ЭИОС КузГТУ третьим лицам.
      </p>
      <p>
        Поступающий соглашается с тем, что во время экзамена будет поводиться видеосъемка и аудиозапись экзамена.
      </p>
      <p>
        Будьте внимательны! За нарушение правил поведения поступающий удаляется с
        вступительного испытания с проставлением неудовлетворительного балла
        независимо от числа правильно выполненных заданий, о чем составляется акт, утверждаемый ответственным
        секретарем приемной комиссии.
      </p>
      <p>
         Поступающий должен в соответствии с графиком пройти процедуру идентификации личности.
        Процедура идентификации личности начинается за <strong> 30 минут</strong> до начала экзамена.
      </p>
      <p>
        <strong> Поступающие, которые не прошли процедуру идентификации личности, к экзамену не допускаются.</strong>
        Согласно расписанию экзаменов поступающий, успешно прошедший идентификацию личности, получает доступ к вступительным испытаниям.
      </p>
      <p>
         На главной странице личного кабинета вы увидете график экзаменов, а также ваши логин,пароль и ссылки
         для подключения к вступительным испытаниям, которые проводятся в
         электронной информационно-образовательной среде (ЭИОС) КузГТУ.
      </p>
      <p>
        Результат экзамена может быть аннулирован в случае нарушений настоящей инструкции и игнорирования замечаний оператора.
      </p>
      <p>
        Увидеть оценки за экзамены можно на следующий день после экзамена на сайте КузГТУ.
      </p>
      <p>
        В случае технического сбоя оборудования или отсутствия интернета во время проведения экзамена не по вине поступающего,
        допускается повторная сдача в резервный день.
        При возникновении технического сбоя обучающийся должен незамедлительно, в день проведения экзамена,
        но не позднее 23:59 по местному времени, проинформировать КузГТУ по адресам электронной почты,
        указанным в Инструкции по проведению экзамена, о невозможности продолжать экзамен.
        КузГТУ рассматривает обращение поступающего, и при подтверждении случая технического сбоя не по вине
        поступающего, допускается сдача экзамена в резервный день.
      </p>
      <div class="text-center text-h6 black--text">
        Минимальные технические требования к персональному компьютеру и программному обеспечению
      </div>
      <br>
          Для дистанционной сдачи экзамена вам потребуется: ПК с  современной версией OC - Windows или MacOS,
          наличие быстрого и стабильного интернета,
          а также современный веб-браузер. Лучше всего подойдут  браузеры:
        <ul>
          <li>
             <a target="firefox_target" href="https://www.mozilla.org/en-US/firefox/products/">
              Firefox
            </a>
          </li>
          <li>
            <a target="chrome_target" href="https://www.google.com/chrome/">
              Chrome
            </a>
          </li>
        </ul>
       <p> В вашем браузере также должны быть включены файлы cookie и JavaScript.</p>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" block @click="$emit('visible_instruction')">
        Понятно
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "InstructionExam",
}
</script>

<style scoped>

</style>
